import Vue from 'vue';

export default {
  namespaced: true,
  state: {
    allRoles: [],
    allStatuses: [],
  },
  mutations: {
    setAllRoles(state, allRoles) {
      state.allRoles = allRoles;
    },
    setAllStatuses(state, allStatuses) {
      state.allStatuses = allStatuses;
    },
  },
  actions: {
    async fetchAllRoles({ state, commit, rootState }) {
      try {
        if (state.allRoles.length === 0) {
          const allRolesResponse =
            await rootState.auth.backendAxios.get('/sponsorship-event/event-roles');
          commit('setAllRoles', allRolesResponse.data);
        }
      } catch (err) {
        Vue.toasted.show(err.response.data, {
          type: 'info',
          duration: 5000,
        });
      }
    },
    async fetchAllStatuses({ state, commit, rootState }) {
      try {
        if (state.allStatuses.length === 0) {
          const allStatusesResponse =
            await rootState.auth.backendAxios.get('/sponsorship-event/event-statuses');
          commit('setAllStatuses', allStatusesResponse.data);
        }
      } catch (err) {
        Vue.toasted.show(err.response.data, {
          type: 'info',
          duration: 5000,
        });
      }
    },
    async fetchEventRole({ rootState }, { eventId }) {
      try {
        const roleResponse =
          await rootState.auth.backendAxios.get(`/sponsorship-event/my-event/id/${eventId}/role`);
        return roleResponse.data;
      } catch (err) {
        // default to lowest role
        return 'viewer';
      }
    },
    async fetchEventStatus({ rootState }, { eventId }) {
      try {
        const statusResponse =
          await rootState.auth.backendAxios
            .get(`/sponsorship-event/my-event/id/${eventId}?fields=status`);
        return statusResponse.data.status;
      } catch (err) {
        return null;
      }
    },
  },
  getters: {
    canEditEvent: () => (role, status) =>
      (status === 'draft') &&
      (role === 'owner' || role === 'editor'),
    canDeleteEvent: () => (role, status) =>
      (status === 'draft' || status === 'pending_approval') &&
      (role === 'owner'),
    canDuplicateEvent: () => role => role === 'owner' || role === 'editor',
    canContactSupportEvent: () => status =>
      status === 'active' || status === 'pending_approval',
  },
};
